module.exports = __webpack_public_path__ + "img/sec13_1desk.5642863a.png";